import { HiMagnifyingGlass } from "react-icons/hi2";
import { ButtonLoading } from "../../../../components/buttons/button-loading";
import ColorsCircles from "../../params/components/colors-roles";
import { Modal, ModalBody } from "reactstrap";
import { useEffect, useState } from "react";
import { useSkillsAction } from "../../../../services/actions/skills.action";
import { useChargesAction } from "../../../../services/actions/charges.action";
import toast from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";
import { normalizeString } from "../../../../helpers/functions";

const EditChargeFromSelectionModal = (props) => {
  const { toggle, open, update, setCharge, charge, clientId, resetSelectCharges} = props;
  const { editCharge, createCharge } = useChargesAction();
  const { listSkills } = useSkillsAction();
  const [skillList, setListSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [showSkills, setShowSkills] = useState(false);

  const handleChange = (key, value) =>
    setCharge((prevValues) => ({ ...prevValues, [key]: value }));

  useEffect(() => {
    const getSkills = async () => {
      const { data } = await listSkills();
      const sortSkills = data.sort((a, b) => {
        return a.name < b.name ? -1 : 1;
      });
      setListSkills(data);
      setFilteredSkills(sortSkills);
    };
    getSkills();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSelectedSkills(charge?.competences);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setFilteredSkills(
      skillList.filter((skill) =>
        normalizeString(skill.name).toLowerCase().includes(normalizeString(searchTerm).toLowerCase())
      )
    );
  }, [searchTerm, skillList]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    let newData = Object.fromEntries(data.entries());
    let competences = charge?.competences.map((skill) => skill.id);
    newData = {
      ...newData,
      id: charge?.id,
      type: "",
      competences,
      currentClientsId: charge?.currentClientsId || "",
    };

    const newId = uuidv4()
    charge?.currentClientsId === "" ?
    createCharge({...newData, id: newId, currentClientsId: clientId}, ()=>{
      setCharge((prevValues)=>({...prevValues, id: newId, currentClientsId: clientId}))
      toast.success("Cargo editado exitosamente", { duration: 4000 });

      toggle();
      update(); 
      resetSelectCharges();
    })
    :
    editCharge(newData, () => {
      toast.success("Cargo editado exitosamente", { duration: 4000 });
      toggle();
      update();
      resetSelectCharges();
    });
  };

  const handleSelectSkill = (skill) => {
    if (!selectedSkills.find((selected) => selected.id === skill.id)) {
      setCharge((prevValues)=>({...prevValues, competences: [...charge.competences, skill]}))
    }
  };

  const handleDeleteSkill = (skill) => {
    setCharge((prevValues)=>({
      ...prevValues,
      competences: charge.competences.filter((skills)=>skills.id !==skill)
    }))
    // setSelectedSkills(selectedSkills.filter((skills) => skills.id !== skill));
  };

  const handleBlur = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setShowSkills(false);
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className="gm-modal-header">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title">Editar Cargo</div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        />
      </div>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div className="gm-modal-form-container">
            <div className="gm-modal-form-section">
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="name">Nombre</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    maxLength={150}
                    value={charge?.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                </div>
              </div>
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="description">Descripción</label>
                  <textarea
                    type="text"
                    id="description"
                    name="description"
                    required
                    maxLength={2000}
                    value={charge?.description}
                    onChange={(e) =>
                      handleChange("description", e.target.value)
                    }
                  />
                </div>
              </div>
              <div className="gm-modal-searchbar-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="skill-search">
                    Competencias: selecciona mínimo 3 y máximo 7 de la lista.{" "}
                  </label>
                  <div
                    className="gm-modal-input-group"
                    onFocus={() => setShowSkills(true)}
                    onBlur={handleBlur}
                    tabIndex={-1}
                  >
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Buscar Competencia"
                      onClick={() => setShowSkills(true)}
                    />

                    {HiMagnifyingGlass}

                    <ul>
                      {showSkills &&
                        filteredSkills.map((skill) => (
                          <li
                            className="gm-modal-li-searchbar"
                            key={skill.id}
                            onClick={() => handleSelectSkill(skill)}
                          >
                            {skill.name}{" "}
                            <div>
                              {skill.colorType.map((element) => (
                                <ColorsCircles colors={element} />
                              ))}
                            </div>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
                <div className="gm-modal-form-group">
                  <div className="gm-modal-input-group">
                    <label>
                      Competencias seleccionadas ({charge?.competences.length}):{" "}
                    </label>
                    <div className="gm-modal-group-selected">
                      {/* {selectedSkills.map((skills) => ( */}
                      {charge?.competences.map((skills) => (
                        <div key={skills.id}>
                          {" "}
                          <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={() => {
                              handleDeleteSkill(skills.id);
                            }}
                          />
                          <span> {skills.name}</span>{" "}
                          <div>
                            {skills.colorType.map((colors) => (
                              <ColorsCircles colors={colors} />
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="gm-modal-buttons">
            <button
              type="button"
              className="gm-secondary-button"
              onClick={toggle}
            >
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Guardar"
              disabled={
                charge?.competences.length < 3 || charge?.competences.length > 7
              }
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default EditChargeFromSelectionModal;
